import { useReactiveVar } from '@apollo/client';
import { DialogTitle, Stack } from '@mui/material';
import { Dialog } from '../../../newComponents/Dialog';
import { DialogProps } from '../../../newComponents/Dialog/Dialog.types';
import { Avatar, IconButton, Typography } from '../../../newComponents';
import { VideoAgreementIdentityVerificationContent } from './VideoAgreementIdentityVerificationContent';
import {
  videoAgreementIdentityVerificationDialogVar,
  resetVideoAgreementIdentityVerificationDialogVar,
} from './VideoAgreementIdentityVerificationDialog.vars';

export const VideoAgreementIdentityVerificationDialog = () => {
  const { open, stepNumberLabel, showDialogTitle, onClose } = useReactiveVar(
    videoAgreementIdentityVerificationDialogVar,
  );

  const dynamicProps: Partial<DialogProps> = showDialogTitle
    ? { maxWidth: 'xl' }
    : { PaperProps: { sx: { backgroundColor: 'black' } } };

  const handleClose = () => {
    resetVideoAgreementIdentityVerificationDialogVar();
    onClose && onClose();
  };

  return (
    <Dialog fullWidth {...dynamicProps} onClose={handleClose} open={open}>
      {showDialogTitle && (
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" gap={2} alignItems="center">
              {stepNumberLabel && (
                <Avatar color="primary" size="tiny">
                  {stepNumberLabel}
                </Avatar>
              )}
              <Typography variant="h6">Verifica tu identidad</Typography>
            </Stack>
            <IconButton icon="close_line" onClick={handleClose} />
          </Stack>
        </DialogTitle>
      )}
      <VideoAgreementIdentityVerificationContent />
    </Dialog>
  );
};
